import { render, staticRenderFns } from "./modal_prescricao_animal.vue?vue&type=template&id=345425b1&scoped=true"
import script from "./modal_prescricao_animal.vue?vue&type=script&lang=js"
export * from "./modal_prescricao_animal.vue?vue&type=script&lang=js"
import style0 from "./modal_prescricao_animal.vue?vue&type=style&index=0&id=345425b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345425b1",
  null
  
)

export default component.exports